module.exports = __webpack_public_path__ + "static/media/print.e7bd83e9.svg";